/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListJobApplicationsForJobJobApplicationFromJSON, ListJobApplicationsForJobJobApplicationToJSON, } from './ListJobApplicationsForJobJobApplication.js';
/**
 * Check if a given object implements the ListJobApplicationsForJobResult interface.
 */
export function instanceOfListJobApplicationsForJobResult(value) {
    if (!('jobId' in value) || value['jobId'] === undefined)
        return false;
    if (!('jobApplications' in value) || value['jobApplications'] === undefined)
        return false;
    return true;
}
export function ListJobApplicationsForJobResultFromJSON(json) {
    return ListJobApplicationsForJobResultFromJSONTyped(json, false);
}
export function ListJobApplicationsForJobResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobId': json['jobId'],
        'jobApplications': (json['jobApplications'].map(ListJobApplicationsForJobJobApplicationFromJSON)),
    };
}
export function ListJobApplicationsForJobResultToJSON(json) {
    return ListJobApplicationsForJobResultToJSONTyped(json, false);
}
export function ListJobApplicationsForJobResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobId': value['jobId'],
        'jobApplications': (value['jobApplications'].map(ListJobApplicationsForJobJobApplicationToJSON)),
    };
}
